<div>
  <img [src]="mercuryLogoPath" class="mercury-logo" alt="Mercury Logo" />
  <div class="col-12 p-0 jumbo-medium text-primary mb-5">Login to Ship</div>
  <form
    [formGroup]="loginForm"
    (submit)="
      enableRecaptchaFlag && !useTurnstile
        ? submitRequestWithCaptcha()
        : submitLogin()
    "
    class="col-12 p-0"
  >
    <div class="form-group mb-4">
      <div class="col-12 p-0 field-label-medium text-tertiary mb-2">
        <label for="emailInput">User Email Address</label>
      </div>
      <div class="col-12 p-0 form-control p-fluid">
        <input
          data-hj-allow
          pInputText
          formControlName="email"
          type="email"
          id="emailInput"
          aria-describedby="emailHelp"
          placeholder="Enter User Email Address"
          class="w-full"
        />

        <me-form-validation-message
          controlName="email"
          label="User Email"
        ></me-form-validation-message>
      </div>
    </div>
    @if (!enableSSO || showPassword) {
      <div class="form-group mb-4">
        <div class="col-12 p-0 field-label-medium text-tertiary mb-2">
          <label for="passwordInput">Password</label>
        </div>
        <div class="form-control col-12 p-0 p-fluid">
          <p-password
            [feedback]="false"
            [toggleMask]="true"
            [required]="true"
            formControlName="password"
            id="passwordInput"
            placeholder="Password"
            inputStyleClass="w-full"
            class="w-full"
          ></p-password>
          <me-form-validation-message
            controlName="password"
            label="Password"
          ></me-form-validation-message>
        </div>
      </div>
    }
    @if (!enableSSO || showPassword) {
      <div class="grid mb-5">
        <div
          class="p-2 text-center ml-auto field-label-medium color-base-blue-blue-500 cursor-pointer"
          routerLink="/forgot-password"
        >
          Forgot password?
        </div>
      </div>
    }
    <div class="col-12 p-0">
      <button
        pButton
        class="p-button-primary w-full button-text-medium"
        [disabled]="
          enableRecaptchaFlag && useTurnstile && !verifiedSuccessfully
        "
        [loading]="!!(formSubmitted | async)"
      >
        <span pButtonLabel>Login</span>
      </button>
    </div>
  </form>

  <div (click)="navigateToBookShipment()" class="button-container secondary">
    <div class="flex flex-row align-items-center">
      <div class="title">Ship as a Guest</div>
      <i class="icon icon-bx-chevron-right ml-auto chevron-icon"></i>
    </div>
    <div class="description subtitle-small">
      Ship without an account! As a guest, you'll pay upfront and complete your
      shipment quickly—no login required.
    </div>
  </div>
</div>

@if (enableRecaptchaFlag) {
  @if (useTurnstile) {
    <div
      #turnstileRef
      class="turnstile-container flex justify-content-center mt-3"
    ></div>
  } @else {
    <re-captcha
      #captchaRef
      (resolved)="resolved($event)"
      [siteKey]="captchaPublicSiteKey"
      size="invisible"
    ></re-captcha>
  }
}
